import React, { useEffect, useState } from "react";

import { motion } from "framer-motion";
import TopBar from "../../../components/TopBar/TopBar";
import { Link } from "react-router-dom";
import ButtonBehance from "../../../components/Button/ButtonBehance";
import Navbar from "../../../components/Navbar/Navbar";
import { client } from "../../../client";
import TopBarSingleProject from "../../../components/TopBar/TopBarSingleProject";

import "./ProjectGraphicsDev.css";

const ProjectGraphicsDev = () => {
  // add this is all pages to reset the Scroll position

  useEffect(() => {
    window.scrollTo(0, 0);

    const handleScroll = () => {};

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // this is for page title

  useEffect(() => {
    // Set the page title when the component mounts
    document.title = "Graphics Design Project - Shreeyash Parsawar | Portfolio";
  }, []);

  // api featch data

  const [projectgraphicsdesignsection, setProjectgraphicsdesignsection] =
    useState([]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const query = `*[_type == "projectgraphicsuxdesign"]{
                  id,
                  projectname,
                  projectlink,
                  projectshortdesc,
                  projectimg{
                  asset->{
                      _id,
                      url
                  }
              }
                  
              } | order(id desc) `;

    client.fetch(query).then((data) => {
      setProjectgraphicsdesignsection(data);
      setLoading(false);
    });
  }, []);

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 3 }}
    >
      {loading ? (
        <div className="spinner"></div>
      ) : (
        <section className="sectionProjectgraphicsDev ">
          <TopBarSingleProject />
          <div className="container-fluid padding_bottom">
            <div className="row">
              {/* ---------------------------------------------------------------------------- */}

              {/* Project  section  */}

              <div className="container-fluid">
                <div className="row">
                  {projectgraphicsdesignsection && (
                    <div className="col-lg-12  pt-5">
                      <h1 className="text-capitalize fontpara">
                        I've completed {projectgraphicsdesignsection.length}{" "}
                        Grachics Design projects, and many more are coming
                        soon....
                      </h1>
                    </div>
                  )}
                </div>
              </div>

              <div className="container-fluid  my-5">
                <div className="row">
                  {projectgraphicsdesignsection &&
                    projectgraphicsdesignsection.map((pdata, index) => (
                      <div className="col-lg-4 col-md-6" key={index}>
                        {/* main div  */}

                        <div className="container-fluid knowledge_div">
                          <div className="row">
                            {/* project photo section  */}

                            <div className="col-lg-12 text-center">
                              <img
                                src={pdata.projectimg.asset.url}
                                className="img-fluid"
                                alt=""
                                style={{}}
                              />
                            </div>

                            {/* project photo section  */}

                            {/* Project Detials section  */}

                            <div className="col-lg-12 d-flex flex-column">
                              <div className="">
                                <h1 className="project_title text-center">
                                  {pdata.projectname}
                                </h1>
                                <p className="project_desc">
                                  {pdata.projectshortdesc
                                    ? pdata.projectshortdesc
                                    : "No Short Description is Given"}
                                </p>
                              </div>

                              <div className="mt-auto text-center">
                                <Link to={pdata.projectlink}>
                                  <ButtonBehance title={"Explore on"} />
                                </Link>
                              </div>
                            </div>

                            {/* Project Detials section  */}
                          </div>
                        </div>

                        {/* main div  */}
                      </div>
                    ))}
                </div>
              </div>
              {/*Project  section  */}

              {/* ---------------------------------------------------------------------------- */}
            </div>
          </div>

          {/* <Navbar /> */}
        </section>
      )}
    </motion.div>
  );
};

export default ProjectGraphicsDev;
